/**
 * Generated by orval v7.2.0 🍺
 * Do not edit manually.
 * BVHI Product Data Platform
 * The backend service api is responsible for managing users, customer data, product catalogs, and api token.
 * OpenAPI spec version: 1.28.12
 */

/**
 * The available sort by criteria to choose from.
 */
export type MessageSortByParam =
  (typeof MessageSortByParam)[keyof typeof MessageSortByParam];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MessageSortByParam = {
  CREATED_AT_ASC: "CREATED_AT_ASC",
  CREATED_AT_DESC: "CREATED_AT_DESC",
  CUSTOMER_NUMBER_ASC: "CUSTOMER_NUMBER_ASC",
  CUSTOMER_NUMBER_DESC: "CUSTOMER_NUMBER_DESC",
  SUPPLIER_CODE_ASC: "SUPPLIER_CODE_ASC",
  SUPPLIER_CODE_DESC: "SUPPLIER_CODE_DESC",
} as const;
